import ReferencePanelButton from "molecules/reference-panel/reference-panel-button";
import React from "react";
import { useBookviewTabPanel } from "utilities/contexts/bookview-tab-panel/use-bookview-tab-panel";
import ReferencePanel from "./reference-panel";
import BookviewUserPreferencesPanel from "./bookview-user-preferences-panel";
import BookviewUserPreferencesButton from "organisms/user-preferences/book-view/book-view-user-preferences-button";
import ShareSpacePanelTab from "molecules/share-space-panel/share-space-panel-tab";
import ShareSpacePanel from "molecules/share-space-panel/share-space-panel";
import useFeatureFlags from "utilities/hooks/use-feature-flags";
import BookviewChatPanelButton from "molecules/bookview-chat-panel/bookview-chat-panel-button";
import BookviewChatPanelContent from "./bookview-chat-panel";
import MobileSecondaryNav from "organisms/mobile-secondary-nav/mobile-secondary-nav";
import useAiChatEnabled from "utilities/hooks/use-ai-chat-enabled";
import useBreakpointRanges from "utilities/hooks/use-breakpoint-ranges";
import BookviewSearchbar from "./bookview-search/bookview-search-bar";
import BookviewSearchPanel from "./bookview-search/bookview-search-panel";
import { useBookviewSearchContext } from "utilities/contexts/bookview-tab-panel/bookview-search-provider";

interface BookviewTabPanelProps {}

export const BOOKVIEW_TAB_PANEL_BASE_CLASS_NAME = "c-bookview-tab-panel";
const BookviewTabPanel: React.FC<BookviewTabPanelProps> = (props) => {
    const {
        isOpen,
        isRefPanelOpen,
        isBookviewUserPreferencesOpen,
        isShareSpacePanelOpen,
        isBookviewChatPanelOpen,
        isBookviewSearchPanelOpen,
    } = useBookviewTabPanel();
    const { allowShareMultiple } = useFeatureFlags();
    const { inMobileView: showMobileNav } = useBreakpointRanges();
    const { enableAIChat } = useAiChatEnabled();
    const { isSearchActive } = useBookviewSearchContext();

    const toggleOpen = `${isOpen ? " -open" : " -closed"}`;
    return (
        <div
            className={`${BOOKVIEW_TAB_PANEL_BASE_CLASS_NAME} ${toggleOpen}`}
            data-test-id={"tab-panel"}>
            <div className={`${BOOKVIEW_TAB_PANEL_BASE_CLASS_NAME}__header `}>
                <div
                    className={`${BOOKVIEW_TAB_PANEL_BASE_CLASS_NAME}__header__actions`}>
                    {showMobileNav ? (
                        <MobileSecondaryNav />
                    ) : (
                        <>
                            <div
                                className={`${BOOKVIEW_TAB_PANEL_BASE_CLASS_NAME}__header__actions__buttons${isSearchActive ? " -hidden" : ""}`}>
                                <BookviewUserPreferencesButton />
                                {allowShareMultiple && <ShareSpacePanelTab />}
                                <ReferencePanelButton />
                                {enableAIChat && <BookviewChatPanelButton />}
                            </div>
                            <div
                                className={`${BOOKVIEW_TAB_PANEL_BASE_CLASS_NAME}__header__actions__search${isSearchActive ? " -expanded" : ""}`}>
                                <BookviewSearchbar />
                            </div>
                        </>
                    )}
                </div>
            </div>
            {isOpen && (
                <>
                    <div
                        className={`${BOOKVIEW_TAB_PANEL_BASE_CLASS_NAME}__content`}>
                        {isBookviewUserPreferencesOpen && (
                            <BookviewUserPreferencesPanel />
                        )}
                        {isShareSpacePanelOpen && <ShareSpacePanel />}
                        {isRefPanelOpen && <ReferencePanel />}
                        {isBookviewChatPanelOpen && (
                            <BookviewChatPanelContent />
                        )}
                        {isBookviewSearchPanelOpen && <BookviewSearchPanel />}
                    </div>
                </>
            )}
        </div>
    );
};

export default BookviewTabPanel;
